/* eslint react/prop-types: 0 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { persistStore, autoRehydrate } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';

import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';

// Component, Route, and Lib
import { routeDidUpdate } from './actions/actions-router';
import { chatBotEligibleCheck } from './actions/action-chat-bot';
import { initAuthPrompt } from './actions/actions-auth-prompt';
import Page from '../lib/page';

import largeScreenRoutes from './routes/LargeScreenRoutes';
import rootReducer from './reducers/index';
import HelpApp from './components/HelpApp';
import getHistory from '../lib/HistoryHelper';
import { getElmoExperiments } from './actions/action-app';
import { elmoExperimentResourceNames } from '../lib/experiments-helper';

const middlewares = [
  thunkMiddleware,
];

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line  global-require
  const createLogger = require('redux-logger');
  middlewares.push(createLogger());
}

const isLoggedIn = Page.isLoggedIn();

const store = createStore(rootReducer,
  undefined,
  compose(autoRehydrate(),
    applyMiddleware(...middlewares)),
);

persistStore(store, {
  storage: asyncSessionStorage,
  whitelist: [],
});

// Todo: below `basename` should be updated to `US`.
const history = getHistory();
const isDesktopLayout = Page.isDesktopLayout();
const isChatBotEligible = Page.getIsChatBotEligible();
const isHomePage = Page.isHomePage();
const chatBotPostServiceEnabled = Page.isChatBotPostServiceEnabled();

window.histTest = history;

const currentLocation = history.location;

store.dispatch(routeDidUpdate(currentLocation));

// TODO: wire to acrtions-router after backend code

history.listen((location) => {
  store.dispatch(routeDidUpdate(location));
});

/**
 * chatBotPostServiceEnabled is the Remote config check for postchatboteligibilty API
 */
if (isDesktopLayout && isLoggedIn && isChatBotEligible && isHomePage && !chatBotPostServiceEnabled) {
  // for opening the chatbot window for C2 on home page without clicking on chatbot prompt
  store.dispatch(chatBotEligibleCheck());
}

if (isLoggedIn && isHomePage) {
  // Initalize Auth prompt display logic for on-call users
  store.dispatch(initAuthPrompt(Page.isDisplayAuthPrompt()));
}

// Get KM search experimentation
store.dispatch(getElmoExperiments(elmoExperimentResourceNames.kmSearch));

const routeConfig = largeScreenRoutes; // Using CSS to control left side display logic
Page.removeSession('showContactOptions');

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <HelpApp sideBar={routeConfig.sideBar} mainContainer={routeConfig.mainContainer} />
    </Router>
  </Provider>,
  document.querySelector('.smarthelp-react-app'),
);
